<template>
  <div class="onboarding">
    <TheHeader
      show-logout
      hide-summary
      hide-hamburger
    />
    <div class="onboarding__container">
      <StepsIndicator 
        :steps="finalSteps"
        :current-step="currentOnboardingStep"
        :is-already-approved="!isAdminApprovalPending"
      />
      
      <div class="onboarding__content flex-grow-1 d-flex">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>

import TheHeader from '@/components/TheHeader.vue'
import StepsIndicator from '@/components/onboarding/StepsIndicator.vue'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'LayoutOnboarding',

  components: {
    TheHeader,
    StepsIndicator
  },

  data() {
    return {
      onboarding: true,
      sellerOnboardingSteps: [
        {
          id: 'mfa',
          label: 'Setup MFA'
        },
        {
          id: 'banking',
          label: 'Bank Information'
        },
        {
          id: 'contract',
          label: 'Sign Agreement'
        },
        {
          id: 'ringba',
          label: 'Ringba Integration'
        },
        {
          id: 'approval',
          label: 'Final Approval'
        }
      ],
      buyerOnboardingSteps: [
        {
          id: 'mfa',
          label: 'Setup MFA'
        },
        {
          id: 'contract',
          label: 'Sign Agreement'
        },
        {
          id: 'approval',
          label: 'Final Approval'
        }
      ]
    }
  },

  computed: {
    ...mapGetters('auth', [
      'isBuyerAccount',
      'isAdminApprovalPending',
      'isMFASetup'
    ]),

    ...mapState('onboarding', [
      'currentOnboardingStep'
    ]),

    finalSteps() {
      const accountSpecificSteps = this.isBuyerAccount ? this.buyerOnboardingSteps : this.sellerOnboardingSteps

      if (this.isAdminApprovalPending) {
        return accountSpecificSteps
      }

      const steps = !this.isMFASetup ? accountSpecificSteps : accountSpecificSteps.filter(step => step.id !== 'mfa')

      return this.isAdminApprovalPending ? steps : steps.filter(step => step.id !== 'approval' && step.id !== 'ringba')
    }
  },
}
</script>

<style lang="scss" scoped>
.onboarding {
  &__container {
    padding-top: 55px;
    display: flex;
    flex: 1;

    @media (max-width: 767px) {
      flex-direction: column;
    }
  }

  &__subtitle {
    // font-size: 14px;
    color: #6b7280;
    margin-bottom: 2rem;
  }

}
</style>
